import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedContract, clearValidationError } from '../../../../../services/ContractService/contractSlice';

const EndDateEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const validationErrors = useAppSelector((state) => state.contract.validationErrors);

  const handleChange = (value: string) => {
    if (contract) {
      dispatch(updateSelectedContract({ endDate: value || null }));
      if (validationErrors.endDate) {
        dispatch(clearValidationError('endDate'));
      }
    }
  };

  if (!contract) return null;

  const displayValue = contract.endDate ? 
    (typeof contract.endDate === 'string' ? 
      contract.endDate.split('T')[0] : 
      contract.endDate) : '';

  return (
    <TextField
      label="End Date"
      type="date"
      value={displayValue}
      onChange={(e) => handleChange(e.target.value)}
      variant="outlined"
      error={!!validationErrors.endDate}
      helperText={validationErrors.endDate}
      size="small"
      sx={{ width: 220 }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default EndDateEditor;
